import { Directive, HostListener, Output, EventEmitter, ElementRef } from '@angular/core';
import { Point } from '../types/point';

@Directive({
  selector: '[ackPan]'
})
export class PanDirective {

  @Output() panChange: EventEmitter<Point>;
  @Output() panStop: EventEmitter<any>;

  constructor(
    private el: ElementRef
  ) {
    this.panChange = new EventEmitter();
    this.panStop = new EventEmitter();
  }

  private isDragging = false;
  private panStart: Point;

  @HostListener('touchstart', ['$event'])
  @HostListener('mousedown', ['$event'])
  public dragstart(event: MouseEvent | TouchEvent) {
    this.isDragging = true;

    if (event instanceof MouseEvent) {
      this.panStart = {
        x: event.clientX,
        y: event.clientY
      };
    }

    // tslint:disable-next-line: no-string-literal
    if (window['TouchEvent'] && event instanceof TouchEvent) {
      this.panStart = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }


  }

  @HostListener('touchend', ['$event'])
  @HostListener('mouseup', ['$event'])
  public dragend(event: MouseEvent) {
    this.isDragging = false;

    setTimeout(() => {
      this.panStop.emit();
    }, 250);

  }

  @HostListener('mousemove', ['$event'])
  public drag(event: any) {

    if (!this.isDragging) { return; }

    // wait a while before emit the event to ensure that user is effectively dragging
    this.panChange.emit(this.getPanOffset(event.clientX, event.clientY, 2));

    this.panStart = {
      x: event.clientX,
      y: event.clientY
    };

  }

  @HostListener('touchmove', ['$event'])
  public touchDrag(event: TouchEvent) {

    if (!this.isDragging) { return; }

    if (event.touches.length > 1) { return; }

    // wait a while before emit the event to ensure that user is effectively dragging
    this.panChange.emit(this.getPanOffset(event.touches[0].clientX, event.touches[0].clientY, 1.5));

    this.panStart = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY
    };

  }

  private getPanOffset(x: number, y: number, correction: number): Point {

    return {
      x: (this.panStart.x - x),
      y: (this.panStart.y - y)
    };
  }

}
